import PropTypes from "prop-types";
import React from "react";

import { createClassNameString } from "@/utils/createClassNameString";

import { ICON_SIZES, ICON_TYPES } from "../../constants/icons";

import "./styles.scss";

export const SettingsIcon = ({ className, iconSize, iconType, ...props }) => {
  if (iconType === ICON_TYPES.OUTLINE) {
    return (
      <svg
        className={createClassNameString([iconSize, className])}
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          clipRule="evenodd"
          d="M10.5808 23.4709C11.0707 23.221 11.6418 23.1839 12.1599 23.3683L13.7614 23.9381C14.4467 24.1819 14.9456 24.7786 15.0642 25.4963L15.1476 26.0009H16.8529L16.9363 25.4963C17.0549 24.7786 17.5538 24.1819 18.2391 23.9381L19.8406 23.3683C20.3587 23.1839 20.9298 23.221 21.4197 23.4709L22.3451 23.9428L23.756 22.6497L23.3806 22.1496C22.9682 21.6001 22.8667 20.8775 23.1117 20.2356L23.6815 18.7432C23.9276 18.0988 24.4883 17.6266 25.1652 17.4939L26 17.3303V14.6709L25.1652 14.5072C24.4883 14.3745 23.9276 13.9024 23.6815 13.258L23.1117 11.7655C22.8667 11.1237 22.9682 10.4011 23.3806 9.85162L23.756 9.35145L22.3451 8.05836L21.4197 8.53031C20.9298 8.78014 20.3587 8.81725 19.8406 8.63291L18.2391 8.06309C17.5538 7.81924 17.0549 7.22255 16.9363 6.50489L16.8529 6.00031H15.1476L15.0642 6.50489C14.9456 7.22255 14.4467 7.81925 13.7614 8.06309L12.1599 8.63291C11.6418 8.81725 11.0707 8.78014 10.5808 8.53031L9.6556 8.05845L8.24499 9.35167L8.62036 9.85216C9.03241 10.4016 9.13376 11.124 8.8888 11.7655L8.31898 13.258C8.07294 13.9024 7.51221 14.3745 6.83532 14.5072L6.00049 14.6709V17.3303L6.83532 17.4939C7.51221 17.6266 8.07294 18.0988 8.31898 18.7432L8.8888 20.2356C9.13376 20.8772 9.03241 21.5996 8.62036 22.149L8.24499 22.6495L9.6556 23.9427L10.5808 23.4709ZM9.32744 26.3552L5.55774 22.8992L7.02036 20.949L6.45053 19.4566L4.00049 18.9762V13.025L6.45053 12.5446L7.02036 11.0522L5.55774 9.102L9.32744 5.64601L11.4895 6.74864L13.091 6.17881L13.451 4.00031H18.5496L18.9096 6.17881L20.511 6.74864L22.6731 5.64601L26.4438 9.102L24.9802 11.0522L25.55 12.5446L28 13.025V18.9762L25.55 19.4566L24.9802 20.949L26.4438 22.8992L22.6731 26.3552L20.5111 25.2526L18.9096 25.8224L18.5496 28.0009H13.451L13.091 25.8224L11.4895 25.2526L9.32744 26.3552ZM15.9997 21C13.2411 21 11 18.7589 11 16.0003C11 13.2418 13.2407 11 15.9997 11C18.7586 11 21 13.2414 21 16.0003C21 18.7593 18.7582 21 15.9997 21ZM15.9997 19C14.3457 19 13 17.6543 13 16.0003C13 14.3459 14.3457 13 15.9997 13C17.6541 13 19 14.3459 19 16.0003C19 17.6543 17.6541 19 15.9997 19Z"
          fillRule="evenodd"
        />
      </svg>
    );
  } else if (iconType === ICON_TYPES.FILLED) {
    return (
      <svg
        className={createClassNameString([iconSize, className])}
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          clipRule="evenodd"
          d="M11.4895 25.2526L9.32744 26.3552L5.55774 22.8992L7.02036 20.949L6.45053 19.4566L4.00049 18.9762V13.025L6.45053 12.5446L7.02036 11.0522L5.55774 9.102L9.32744 5.64601L11.4895 6.74864L13.091 6.17881L13.451 4.00031H18.5496L18.9096 6.17881L20.511 6.74864L22.6731 5.64601L26.4438 9.102L24.9802 11.0522L25.55 12.5446L28 13.025V18.9762L25.55 19.4566L24.9802 20.949L26.4438 22.8992L22.6731 26.3552L20.5111 25.2526L18.9096 25.8224L18.5496 28.0009H13.451L13.091 25.8224L11.4895 25.2526ZM12 16.0004C12 18.2058 13.7942 20 15.9996 20C18.2054 20 20 18.2058 20 16.0004C20 13.7946 18.2054 12 15.9996 12C13.7942 12 12 13.7946 12 16.0004Z"
          fillRule="evenodd"
        />
      </svg>
    );
  }

  return null;
};

SettingsIcon.propTypes = {
  className: PropTypes.string,
  iconSize: PropTypes.oneOf(Object.values(ICON_SIZES)),
  iconType: PropTypes.oneOf(Object.values(ICON_TYPES)),
};

SettingsIcon.defaultProps = {
  className: undefined,
  iconSize: ICON_SIZES.DEFAULT,
  iconType: ICON_TYPES.OUTLINE,
};
